export const USER_ROLES_ENUM = {
  superAdmin: "super_admin",
  ministry: "ministry",
  state: "state",
  district: "district",
  hospital: "hospital",
};

export const BATCH_RETIRE_TYPES_ENUMS = {
  used: "used",
  damaged: "damaged",
  expired: "expired",
};

export const BATCH_RETIRE_TYPES_ARRAY = [
  {
    name: "Used",
    value: BATCH_RETIRE_TYPES_ENUMS?.used,
  },
  {
    name: "Damaged",
    value: BATCH_RETIRE_TYPES_ENUMS?.damaged,
  },
  {
    name: "Expired",
    value: BATCH_RETIRE_TYPES_ENUMS?.expired,
  },
];

export const userRolesEnumArr = [
  {
    name: "Super Admin",
    value: "super_admin",
  },
  {
    name: "Ministry",
    value: "ministry",
  },
  {
    name: "State",
    value: "state",
  },
  {
    name: "District",

    value: "district",
  },
  {
    name: "Hospital",
    value: "hospital",
  },
];

export const RequestEnumArr = [
  {
    name: "Ministry",
    value: USER_ROLES_ENUM?.ministry,
  },
  {
    name: "Province",
    value: USER_ROLES_ENUM?.state,
  },
  {
    name: "District",
    value: USER_ROLES_ENUM?.district,
  },
  {
    name: "Hospital",
    value: USER_ROLES_ENUM?.hospital,
  },
];
export const BATCH_MAIN_TYPES_ENUM = {
  VACCINES: "vaccine",
  MEDICAL_EQUIPMENTS: "medical_equipments",
  MEDICINES: "medicines",
  OTHERS: "others",
};

export const BATCH_MAIN_TYPES_ENUM_ARRAY = [
  {
    name: "Vaccines",
    value: BATCH_MAIN_TYPES_ENUM.VACCINES,
  },
  // {
  //   name: "Medical Equipment",
  //   value: BATCH_MAIN_TYPES_ENUM.MEDICAL_EQUIPMENTS,
  // },
  // {
  //   name: "Medicines",
  //   value: BATCH_MAIN_TYPES_ENUM.MEDICINES,
  // },
  // {
  //   name: "Others",
  //   value: BATCH_MAIN_TYPES_ENUM.OTHERS,
  // },
];

export const BATCH_SUB_TYPES_ENUM_ARRAY = [
  {
    name: "Pfizer",
    value: "pfizer",
  },
  // {
  //   name: "Moderna",
  //   value: "madorna",
  // },
];
export const TEMPRATURE_TYPES_ENUM_ARRAY = [
  {
    name: "Fahrenheit",
    value: "Fahrenheit",
  },
  {
    name: "Celcius",
    value: "Celcius",
  },
  {
    name: "Kelvin",
    value: "Kelvin",
  },
];
export const TEMPRATURE_ENUM_ARRAY = [
  {
    name: "-90 to -60",
    value: "ultra_cold",
  },
  {
    name: "-25 to -15",
    value: "cold",
  },
  {
    name: "-8 to 2",
    value: "normal",
  },
];

export const BATCH_CREATE_ENUMS = {
  ISSUE: "issue",
  TRANSFER: "transfer",
  RETIRE: "retire",
};
